import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

type IconCallProps = Omit<InceptIconProps, 'children' | 'viewBox'> & {
  viewBox?: string;
};

const IconCallComponent: React.FC<IconCallProps> = ({
  color = 'var(--chakra-colors-brand-primary-solid, #30B7FD)',
  fillColor = 'var(--chakra-colors-brand-primary-fg, #00293C)',
  viewBox = '0 0 32 32',
  ...props
}: IconCallProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g>
      <path
        d="M28.4998 15.95C28.1998 15.95 27.9998 15.75 27.9998 15.45C27.9998 9.15 22.8498 4 16.5498 4C16.2498 4 16.0498 3.8 16.0498 3.5C16.0498 3.2 16.2498 3 16.5498 3C23.3998 3 28.9998 8.6 28.9998 15.45C28.9998 15.75 28.7998 15.95 28.4998 15.95Z"
        fill={color as string}
      />
      <path
        d="M25.2498 15.95C24.9498 15.95 24.7498 15.75 24.7498 15.45C24.7498 10.95 21.0498 7.25 16.5498 7.25C16.2498 7.25 16.0498 7.05 16.0498 6.75C16.0498 6.45 16.2498 6.25 16.5498 6.25C21.5998 6.25 25.7498 10.35 25.7498 15.45C25.7498 15.75 25.4998 15.95 25.2498 15.95Z"
        fill={color as string}
      />
      <path
        d="M21.9998 15.95C21.6998 15.95 21.4998 15.75 21.4998 15.45C21.4998 12.75 19.2998 10.5 16.5498 10.5C16.2498 10.5 16.0498 10.3 16.0498 10C16.0498 9.7 16.2498 9.5 16.5498 9.5C19.7998 9.5 22.4998 12.2 22.4998 15.45C22.4998 15.75 22.2498 15.95 21.9998 15.95Z"
        fill={color as string}
      />
      <path
        d="M21.6998 29.0008C20.6998 29.0008 19.5498 28.8008 18.3498 28.4508C15.3498 27.5008 12.1498 25.4508 9.3998 22.6508C3.4498 16.7008 1.2498 9.55082 4.4498 6.40082C5.0998 5.75082 6.1998 4.95082 6.9998 4.35082C7.3498 4.10082 7.8498 4.00082 8.2998 4.10082C8.7498 4.20082 9.1498 4.45082 9.3998 4.85082L12.8498 10.3508C13.0998 10.7508 13.1498 11.2008 13.0498 11.6008C12.9498 12.0508 12.6998 12.4008 12.2998 12.6508L10.2498 13.8508C10.0998 13.9508 9.9998 14.1008 9.9498 14.3008C9.8998 14.5008 9.9498 14.6508 10.0498 14.8008C10.8998 15.9508 11.9998 17.2508 13.3498 18.6508C14.7498 20.0508 15.9998 21.1508 17.1998 21.9508C17.3498 22.0508 17.5498 22.1008 17.6998 22.0508C17.8998 22.0008 18.0498 21.9008 18.1498 21.7508L19.3498 19.7008C19.5998 19.3008 19.9498 19.0508 20.3998 18.9508C20.8498 18.8508 21.2998 18.9008 21.6498 19.1508L27.1498 22.6008C27.5498 22.8508 27.7998 23.2508 27.8998 23.7008C27.9998 24.1508 27.8998 24.6008 27.6498 25.0008C27.0998 25.8008 26.2498 26.9008 25.5998 27.5508C24.6498 28.5008 23.2998 29.0008 21.6998 29.0008Z"
        fill={fillColor as string}
      />
    </g>
  </InceptIcon>
);

export const IconCall = memo(IconCallComponent);
